/*
 * @Author: c.k
 * @Date: 2022-07-25 10:39:30
 * @LastEditors: c.k
 * @LastEditTime: 2022-07-25 16:48:22
 * @Descripttion:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAnimateNumber from 'vue-animate-number'

Vue.use(VueAnimateNumber)
Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
